/* NutriCaps – aumento de ticket
 * 1) Página do produto mostra o preço por pote em cada kit (abre em 1 pote, padrão)
 * 2) Barra fixa de compra no celular
 * 3) Oferta "leve 2 potes" dentro do carrinho lateral
 */
(function () {
  'use strict';

  var css = '' +
    '.pdp__variant-unit{display:block;font-size:.75rem;font-weight:600;color:hsl(var(--primary));margin-top:.125rem;}' +
    '.nc-sticky{position:fixed;left:0;right:0;bottom:0;z-index:900;display:none;align-items:center;gap:.75rem;padding:.625rem .875rem calc(.625rem + env(safe-area-inset-bottom));background:#fff;box-shadow:0 -6px 20px rgba(0,0,0,.12);transform:translateY(110%);transition:transform .25s ease;}' +
    '.nc-sticky.is-visible{transform:translateY(0);}' +
    '.nc-sticky__info{flex:1;min-width:0;line-height:1.2;}' +
    '.nc-sticky__variant{display:block;font-size:.75rem;color:hsl(var(--muted-foreground));white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}' +
    '.nc-sticky__price{display:block;font-weight:800;font-size:1.0625rem;color:hsl(var(--primary));}' +
    '.nc-sticky__btn{flex-shrink:0;border:0;border-radius:.75rem;padding:.8rem 1.1rem;background:hsl(var(--primary));color:#fff;font-weight:700;font-size:.9375rem;font-family:inherit;cursor:pointer;}' +
    '@media (max-width:767px){.nc-sticky{display:flex;}}' +
    '@media (max-width:767px){body.nc-sticky-on .whatsapp-float{bottom:84px !important;transition:bottom .25s ease;}}' +
    '.nc-up{grid-column:1 / -1;margin-top:.5rem;padding:.625rem .75rem;border:1px dashed hsl(var(--primary) / .45);border-radius:.625rem;background:hsl(var(--primary) / .06);display:flex;align-items:center;gap:.625rem;font-size:.8125rem;line-height:1.35;color:hsl(var(--foreground));}' +
    '.nc-up strong{color:hsl(var(--primary));}' +
    '.nc-up__txt{flex:1;min-width:0;}' +
    '.nc-up__btn{flex-shrink:0;border:0;border-radius:999px;padding:.5rem .875rem;background:hsl(var(--primary));color:#fff;font-weight:700;font-size:.8125rem;font-family:inherit;cursor:pointer;}' +
    '.nc-up__btn[disabled]{opacity:.6;}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  var fmt = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
  function brl(n) { return fmt.format(n); }
  // "R$ 1.169,90" -> 1169.9
  function parseBRL(s) {
    if (!s) return NaN;
    var t = String(s).replace(/[^\d,]/g, '').replace(',', '.');
    return parseFloat(t);
  }
  function qtyFromTitle(t) {
    var m = String(t || '').trim().match(/^(\d+)\s*(pote|potes|frasco|frascos)\b/i);
    return m ? parseInt(m[1], 10) : 0;
  }

  /* ---------- 1) Página do produto ---------- */
  function initProductPage() {
    var btns = Array.prototype.slice.call(document.querySelectorAll('[data-variant-btn]'));
    if (!btns.length) return;

    // Preço por pote em cada kit
    btns.forEach(function (b) {
      var titleEl = b.querySelector('.pdp__variant-title');
      var priceEl = b.querySelector('.pdp__variant-price');
      var n = qtyFromTitle(titleEl ? titleEl.textContent : '');
      var price = parseBRL(b.getAttribute('data-price'));
      if (n > 1 && price > 0 && priceEl && !b.querySelector('.pdp__variant-unit')) {
        var s = document.createElement('span');
        s.className = 'pdp__variant-unit';
        s.textContent = brl(Math.round((price / n) * 100) / 100) + ' cada';
        priceEl.insertAdjacentElement('afterend', s);
      }
    });
    // (Removido em 31/10/2026: não pré-seleciona mais o kit de 2 — a página abre em 1 pote)
  }

  /* ---------- 2) Barra fixa no celular ---------- */
  function initStickyBar() {
    var form = document.getElementById('product-form');
    var buyBtn = form && form.querySelector('button[name="buy-now"]');
    var priceEl = document.querySelector('[data-current-price]');
    if (!form || !buyBtn || !priceEl || buyBtn.disabled) return;

    var bar = document.createElement('div');
    bar.className = 'nc-sticky';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<div class="nc-sticky__info"><span class="nc-sticky__variant"></span><span class="nc-sticky__price"></span></div>' +
      '<button type="button" class="nc-sticky__btn">Comprar agora</button>';
    document.body.appendChild(bar);
    var vEl = bar.querySelector('.nc-sticky__variant');
    var pEl = bar.querySelector('.nc-sticky__price');

    function sync() {
      pEl.textContent = priceEl.textContent.trim();
      var active = document.querySelector('[data-variant-btn].is-active .pdp__variant-title');
      var title = document.querySelector('.pdp__title');
      var name = title ? title.childNodes[0].textContent.trim() : '';
      vEl.textContent = (active ? active.textContent.trim() + ' · ' : '') + name;
    }
    sync();
    new MutationObserver(sync).observe(priceEl, { childList: true, characterData: true, subtree: true });
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-variant-btn]')) setTimeout(sync, 0);
    });

    bar.querySelector('.nc-sticky__btn').addEventListener('click', function () {
      buyBtn.click();
    });

    function show(v) {
      bar.classList.toggle('is-visible', v);
      bar.setAttribute('aria-hidden', v ? 'false' : 'true');
      document.body.classList.toggle('nc-sticky-on', v);
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        // aparece só depois que o cliente rolou além dos botões
        show(!e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(form);
    }
  }

  /* ---------- 3) Oferta no carrinho lateral ---------- */
  var productCache = {};
  function getProduct(handle) {
    if (productCache[handle]) return productCache[handle];
    productCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .catch(function () { return null; });
    return productCache[handle];
  }

  function initCartUpsell() {
    var itemsEl = document.querySelector('[data-cd-items]');
    if (!itemsEl) return;
    var busy = false, timer = null;

    function decorate() {
      if (busy) return;
      fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          (cart.items || []).forEach(function (it) {
            if (it.quantity !== 1) return;
            var opt = (it.options_with_values && it.options_with_values[0]) ? it.options_with_values[0].value : it.variant_title;
            if (qtyFromTitle(opt) !== 1) return;
            getProduct(it.handle).then(function (p) {
              if (!p || !p.variants) return;
              var two = null;
              p.variants.forEach(function (v) { if (!two && qtyFromTitle(v.option1 || v.title) === 2 && v.available) two = v; });
              if (!two) return;
              var one = it.final_price / 100, twoPrice = two.price / 100;
              var save = Math.round((one * 2 - twoPrice) * 100) / 100;
              if (save <= 0) return;
              var li = itemsEl.querySelector('.cd-item[data-key="' + (window.CSS && CSS.escape ? CSS.escape(it.key) : it.key) + '"]');
              if (!li || li.querySelector('.nc-up')) return;
              var unit = /frasco/i.test(two.option1 || two.title) ? 'frascos' : 'potes';
              var box = document.createElement('div');
              box.className = 'nc-up';
              box.innerHTML = '<span class="nc-up__txt">💡 Leve <strong>2 ' + unit + ' por ' + brl(twoPrice) + '</strong> (' + brl(twoPrice / 2) + ' cada) e economize <strong>' + brl(save) + '</strong></span>' +
                '<button type="button" class="nc-up__btn">Quero 2</button>';
              li.appendChild(box);
              box.querySelector('.nc-up__btn').addEventListener('click', function (ev) {
                ev.preventDefault();
                ev.stopPropagation();
                var b = ev.currentTarget;
                b.disabled = true; b.textContent = '...';
                busy = true;
                fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: it.key, quantity: 0 }) })
                  .then(function () {
                    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: two.id, quantity: 1 }) });
                  })
                  .then(function () { busy = false; if (window.NutriCart) return window.NutriCart.refresh(); })
                  .catch(function () { busy = false; if (window.NutriCart) window.NutriCart.refresh(); });
              });
            });
          });
        })
        .catch(function () {});
    }

    new MutationObserver(function (muts) {
      // ignora as mudanças causadas pela própria oferta
      var relevant = muts.some(function (m) {
        return Array.prototype.some.call(m.addedNodes, function (n) { return n.nodeType === 1 && n.classList && n.classList.contains('cd-item'); });
      });
      if (!relevant) return;
      clearTimeout(timer);
      timer = setTimeout(decorate, 50);
    }).observe(itemsEl, { childList: true });
  }

  function init() {
    initProductPage();
    initStickyBar();
    initCartUpsell();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
